"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _elevation = _interopRequireDefault(require("../../utils/elevation"));

var Box = _styledComponents["default"].div.withConfig({
  displayName: "Box",
  componentId: "sc-11fxl3a-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " box-sizing:border-box;"], _styledSystem.color, _styledSystem.width, _styledSystem.space, _styledSystem.height, _styledSystem.fontSize, _styledSystem.fontFamily, _styledSystem.borderRadius, _styledSystem.border, _styledSystem.borderColor, _elevation["default"], _styledSystem.display, _styledSystem.maxWidth, _styledSystem.minWidth, _styledSystem.maxHeight, _styledSystem.minHeight, _styledSystem.size, _styledSystem.position, _styledSystem.zIndex, _styledSystem.top, _styledSystem.right, _styledSystem.left, _styledSystem.bottom);

Box.propTypes = (0, _extends2["default"])({}, _styledSystem.color.propTypes, {}, _styledSystem.width.propTypes, {}, _styledSystem.space.propTypes, {}, _styledSystem.border.propTypes, {}, _styledSystem.borderRadius.propTypes, {}, _styledSystem.height.propTypes, {}, _styledSystem.fontSize.propTypes, {}, _styledSystem.fontFamily.propTypes);
Box.defaultProps = {
  bg: "transparent",
  width: "inherit",
  m: 0,
  p: 0,
  border: "none",
  height: "auto",
  fontSize: 4,
  fontFamily: "sansSerif"
};
var _default = Box;
exports["default"] = _default;